import type { consents as en } from '@/i18n/locales/en/consents';
import type { Translation } from '@/i18n/types';

export const consents: Translation<typeof en> = {
  title: 'Οι συγκαταθέσεις σας',
  empty: 'Δεν υπάρχουν αιτήματα συγκατάθεσης που να σας αφορούν.',
  collectiveNote:
    'Ισχύει συλλογική εγγραφή στο τμήμα· η προσωπική σας απάντηση δεν έχει ισχύ όσο αυτή παραμένει.',
  table: {
    department: 'Τμήμα',
    status: 'Κατάσταση',
    basis: 'Ισχύουσα βάση',
  },
  status: {
    pending: 'Αναμονή της απάντησής σας',
    granted: 'Χορηγήθηκε',
    denied: 'Απορρίφθηκε',
  },
  basis: {
    personal: 'Προσωπική',
    collective: 'Συλλογική',
  },
  actions: {
    grant: 'Χορήγηση',
    deny: 'Απόρριψη',
    withdraw: 'Ανάκληση',
  },
};
